var LatLng = /** @class */ (function () {
    function LatLng() {
    }
    return LatLng;
}());
export { LatLng };
//# sourceMappingURL=lat-lang.js.map